module.exports = __webpack_public_path__ + "img/sv86.d9f4bcb1.svg";